export default "__VITE_ASSET__BBSa$qKF__"